import { render, staticRenderFns } from "./CarouselDotsTemplate.vue?vue&type=template&id=3d07e0e1"
import script from "./CarouselDotsTemplate.vue?vue&type=script&lang=js"
export * from "./CarouselDotsTemplate.vue?vue&type=script&lang=js"
import style0 from "./CarouselDotsTemplate.vue?vue&type=style&index=0&id=3d07e0e1&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports